import type { TFunction } from 'i18next';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import type { IColumn } from '@feathr/components';
import { ContextMenu, TableColumnHeader } from '@feathr/components';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

interface IBuildOptionsColumnArgs<TItem> {
  renderItems: (original: TItem) => ReactNode;
  t: TFunction;
  width?: number;
}

/**
 * Returns the trailing "Options" column used by every prototype table. The
 * caller supplies a `renderItems` function that produces the ContextMenu
 * children for a given row.
 */
function buildOptionsColumn<TItem extends object>({
  renderItems,
  t,
  width = 80,
}: IBuildOptionsColumnArgs<TItem>): IColumn<TItem> {
  return {
    id: 'options',
    Header: TableColumnHeader({ title: t('Options') }),
    width,
    sortable: false,
    className: tableStyles.cellCenter,
    Cell({ original }): JSX.Element {
      return (
        <ContextMenu buttonType={'icon'} position={'left-start'}>
          {renderItems(original)}
        </ContextMenu>
      );
    },
  };
}

export default buildOptionsColumn;
